/*
  SCK (Oct 18, 2026): Mobile predictive search (the full-screen #custom-popup overlay, <=767px).
  Works on the markup theme.js already renders; it does not fetch, debounce, open or close search.
  1. Section order: moves the existing nodes so the DOM (reading/focus) order matches the screen:
     actions, Products, "View all results", Suggestions, Collections. Nothing is cloned.
  2. "No products" note when other results exist but no products matched.
  3. Thumbnails: adds a 360px source next to the theme's 80/160/240px ones, with accurate sizes,
     so the larger mobile thumbnails stay sharp on 3x screens.
  4. Viewport: while the overlay is open, sizes it to window.visualViewport (on-screen keyboard,
     browser bars, rotation) via --sck-vv-h / --sck-vv-top, and clears them on close.
  Desktop never runs any of this: everything is gated on the mobile media query and #custom-popup.
*/
(function () {
  if (window.__sckPredictiveSearchMobile) return;
  window.__sckPredictiveSearchMobile = true;

  var mobile = window.matchMedia('(max-width: 767px)');
  var DONE = 'data-sck-mobile';

  function overlay() { return document.getElementById('custom-popup'); }
  function panel() {
    var o = overlay();
    return o ? o.querySelector('#predictive-search') : null;
  }
  function isOpen(o) {
    return !!o && window.getComputedStyle(o).display !== 'none';
  }

  // ---------- 1-3: arrange freshly rendered results ----------
  function arrange() {
    if (!mobile.matches) return;
    var p = panel();
    if (!p) return;
    var results = p.querySelector('#predictive-search-results');
    if (!results || results.hasAttribute(DONE)) return;
    results.setAttribute(DONE, '1');

    var group1 = results.querySelector(':scope > .results__group-1');
    var group2 = results.querySelector(':scope > .results__group-2');
    var buttons = p.querySelector(':scope > .results__buttons');

    if (group2) {
      results.insertBefore(group2, results.firstChild);
      if (buttons) results.insertBefore(buttons, group2.nextSibling);
      if (group1) results.appendChild(group1);

      if (!group2.querySelector('.results--products')) {
        var input = overlay().querySelector('input[type="search"]');
        var term = input ? input.value.trim() : '';
        if (term) {
          var note = document.createElement('p');
          note.className = 'sck-ps-no-products';
          note.textContent = 'No products found for \u201C' + term + '\u201D.';
          group2.insertBefore(note, group2.firstChild);
        }
      }
    }

    var imgs = results.querySelectorAll('.results-products__image img');
    for (var i = 0; i < imgs.length; i++) addLargerSource(imgs[i]);
  }

  function addLargerSource(img) {
    var srcset = img.getAttribute('srcset') || '';
    if (!srcset || /\s360w/.test(srcset)) return;
    var entries = srcset.split(',');
    var last = entries[entries.length - 1].trim().split(/\s+/)[0];
    if (!/[?&]width=\d+/.test(last)) return;
    var bigger = last.replace(/([?&]width=)\d+/, '$1360');
    img.setAttribute('srcset', srcset + ', ' + bigger + ' 360w');
    img.setAttribute('sizes', '(max-width: 767px) 124px, 88px');
  }

  // ---------- 4: visual viewport sizing ----------
  var vvTimer = null;
  function fitViewport() {
    vvTimer = null;
    var o = overlay();
    if (!o) return;
    if (!mobile.matches || !isOpen(o)) {
      if (o.style.getPropertyValue('--sck-vv-h')) o.style.removeProperty('--sck-vv-h');
      if (o.style.getPropertyValue('--sck-vv-top')) o.style.removeProperty('--sck-vv-top');
      return;
    }
    var vv = window.visualViewport;
    var h = Math.round(vv ? vv.height : window.innerHeight) + 'px';
    var top = Math.round(vv ? vv.offsetTop : 0) + 'px';
    // Only write on change: the overlay observer watches this same style attribute.
    if (o.style.getPropertyValue('--sck-vv-h') !== h) o.style.setProperty('--sck-vv-h', h);
    if (o.style.getPropertyValue('--sck-vv-top') !== top) o.style.setProperty('--sck-vv-top', top);
  }
  function scheduleFit() {
    if (vvTimer === null) vvTimer = window.setTimeout(fitViewport, 16);
  }

  function init() {
    var o = overlay();
    var p = panel();
    if (!o || !p) return;

    // theme.js replaces the panel's innerHTML on every result; arrange each new render once.
    new MutationObserver(arrange).observe(p, { childList: true });
    // The overlay is shown/hidden by jQuery fadeIn/fadeOut (inline style changes).
    new MutationObserver(scheduleFit).observe(o, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleFit, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleFit, { passive: true });
    }
    window.addEventListener('resize', scheduleFit, { passive: true });
    window.addEventListener('orientationchange', scheduleFit, { passive: true });
    if (mobile.addEventListener) mobile.addEventListener('change', scheduleFit);

    arrange();
    scheduleFit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
